import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useDetectMobileView } from "../../../redux/hooks/superAdminCustomHooks/hooks";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const abbreviateLabel = (label) => {
  const words = label.split(" ");
  if (words.length === 1) return label.slice(0, 4).toUpperCase();
  return words.map((word) => word[0].toUpperCase()).join("");
};

const ModulesChart = ({ modulesData }) => {
  const [isMobile, setIsMobile] = useState(false);
  const mobileView = useDetectMobileView();

  useEffect(() => {
    setIsMobile(mobileView);
  }, [mobileView]);

  const fullLabels = modulesData?.modules?.map((m) => m.name) || [];
  const abbreviatedLabels = fullLabels.map(abbreviateLabel);
  const labels = isMobile ? abbreviatedLabels : fullLabels;

  const values = modulesData?.modules?.map((m) => m.client_count) || [];

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: labels.map((_, i) =>
          i % 2 === 0 ? "#FF6B6B" : "#FFC107"
        ),
         categoryPercentage: 0.5,
      barPercentage: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "Modules Users Analysis",
        font: { size: 14 },
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => fullLabels[tooltipItems[0].dataIndex],
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          font: { size: 11 },
          callback: function (val, index) {
            return labels[index];
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: { color: "rgba(0,0,0,0.1)" },
        ticks: { font: { size: 11 } },
      },
    },
  };

  return (
    <div
      className="w-full bg-white p-4 rounded-lg shadow-sm"
      style={{ height: "420px" }}
    >
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default ModulesChart;
